import { StatusCodes } from "http-status-codes";
import { Langs } from "./domain/enums/common/LangsEnum";
import { PaginationEnum } from "./domain/enums/common/PaginationEnum";
import { SystemEventType } from "./domain/enums/SystemEventTypeEnum";
import { SystemEventParentType } from "./domain/enums/SystemEventParentTypeEnum";

export const translations = {
    ua: {
        translation: {
            languages: {
                [Langs.UA]: "Українська",
                [Langs.EN]: "Англійська",
            },
            pagination: {
                show: "Показувати",
                [PaginationEnum.SHOW_ALL]: "Всі",
                [PaginationEnum.SHOW_10]: "10",
                [PaginationEnum.SHOW_20]: "20",
                [PaginationEnum.SHOW_50]: "50",
                [PaginationEnum.SHOW_100]: "100",
            },
            errors: {
                common: "Несподівана помилка",
                validation: {
                    min: "Мінімальне значення ",
                    max: "Максимальне значення ",
                    required: "Обов'язкове поле",
                    invalidOption: "Некоректне значення",
                    invalidNumber: "Некоректне число",
                    invalidEmail: "Некоректна адреса електронної пошти",
                    requireAtLeastOne:
                        "Обов'язкова наявність хоча б одного з полів",
                    invalidPhone: "Некоректний номер телефону",
                    password: {
                        minSymbols:
                            "Мінімальна кількість спеціальних символів - 1",
                        minLowercase:
                            "Мінімальна кількість символів в нижньому регістрі - 1",
                        minUppercase:
                            "Мінімальна кількість символів в верхньому регістрі - 1",
                        minNumbers: "Мінімальна кількість чисел - 1",
                        passwordsMustMatch: "Паролі не співпадають",
                    },
                    syntaxError: "Присутнє некоректне значення",
                    atLeastOneValidElement:
                        "Потрібен хоча б один коректний елемент",
                },
                response: {
                    [StatusCodes.UNAUTHORIZED]:
                        "Несанкціонований доступ або невірний пароль",
                    [StatusCodes.BAD_REQUEST]: "Присутнє некоректне значення",
                },
                deleteFailed: "Не вдалося видалити",
                webSocketConnectionFailed: "Не вдалося підключитися до WebSocket сервера",
            },
            auth: {
                fields: {
                    firstName: "Ім'я",
                    lastName: "Прізвище",
                    middleName: "По-батькові",
                    email: "Електронна пошта",
                    phone: "Телефон",
                    password: "Пароль",
                    confirmPassword: "Підтвердження паролю",
                },
                actions: {
                    register: "Зареєструватися",
                    login: "Увійти",
                    logout: "Вийти",
                    changePassword: "Змінити пароль",
                },
                register: {
                    title: "Реєстрація",
                    success:
                        "Реєстрація успішна! Будь ласка, перевірте вашу електронну пошту для підтвердження.",
                },
                login: {
                    title: "Вхід",
                },
                confirmation: {
                    title: "Підтвердження реєстрації",
                    subtitle:
                        "Будь ласка, зачекайте, поки ми підтвердимо вашу реєстрацію.",
                    subtitleLink: "Перейти на головну",
                    inProcess: "Обробка...",
                    error: "Сталася помилка під час підтвердження.",
                    alreadyExist: "Цей обліковий запис вже підтверджено.",
                    expired: "Термін дії токена підтвердження закінчився.",
                    success: "Ваш обліковий запис успішно підтверджено!",
                    link: "Перейти до авторизації",
                },
            },
            console: {
                sidebar: {
                    expand: "Відкрити",
                    menu: "Меню",
                    usersPage: "Користувачі",
                    logOut: "Вихід",
                    rolesPage: "Ролі",
                    themetoggle: "Зміна теми",
                    languageToggle: "Зміна мови",
                    productFeaturesPage: "Функції продукту",
                    newsPage: "Новини",
                    coursesPage: "Курси",
                    systemEventsPage: "Системні події",
                    managementPage: "Керівництво",
                    eventsPage: "Події",
                    partnersPage: "Партнери",
                    developmentHistoryPage: "Історія розвитку",
                    contactsPage: "Контакти",
                },
                common: {
                    cancel: "Відміна",
                    roleId: "Роль",
                    filters: "Фільтри",
                    resetFilters: "Збросити фільтри",
                    apply: "Застосувати",
                    ok: "ОК",
                    uploadImage: "Завантажити зображення",
                    all: "Всі",
                    save: "Зберегти",
                    saving: "Збереження...",
                    cover: "Обкладинка",
                    create: "Створити",
                    deleteSuccess: "Успішно видалено",
                    success: "Успіх",
                    translateFromDefault: "Перекласти з мови за замовчуванням",
                    fillDefaultLangFirst:
                        "Будь ласка, спочатку заповніть мову за замовчуванням - ",
                },
                users: {
                    table: {
                        id: "Ідентифікатор",
                        email: "Електронна пошта",
                        role: "Роль",
                        firstName: "Ім'я",
                        lastName: "Прізвище",
                        middleName: "По-батькові",
                        phone: "Телефон",
                        actions: "Дії",
                    },
                },
                roles: {
                    table: {
                        id: "Ідентифікатор",
                        name: "Назва",
                        productFeatureCount: "Кількість функцій продукту",
                        add: "Додати функцію до ролі",
                    },
                },
                productFeatures: {
                    table: {
                        id: "Ідентифікатор",
                        name: "Назва функції",
                        description: "Опис",
                    },
                },
                news: {
                    table: {
                        title: "Заголовок",
                        shortContent: "Короткий зміст",
                        content: "Зміст",
                        imgUrl: "Головне зображення",
                        creatorId: "ID Автора",
                    },
                    viewNews: "Перегляд новини",
                    createNews: "Створити новину",
                    editNews: "Редагувати новину",
                    view: "Переглянути",
                    edit: "Редагувати",
                    delete: "Видалити",
                    deleteConfirmTitle: "Видалити новину",
                    deleteConfirmMessage:
                        "Ви впевнені, що хочете видалити цю новину?",
                    deleteConfirmDelete: "Видалити",
                    deleteConfirmText:
                        "Ця дія є незворотною. Будь ласка, підтвердіть, що ви хочете видалити цю новину.",
                    copy: "Скопіювати айді в буфер обміну",
                    newsUpdated: "Новину успішно оновлено",
                },
                events: {
                    table: {
                        title: "Заголовок",
                        subtitle: "Підзаголовок",
                        description: "Опис",
                        eventDate: "Дата і час проведення",
                        location: "Локація",
                        format: "Формат",
                        imgUrl: "Головне зображення",
                        creatorId: "ID Автора",
                    },
                    location: {
                        online: "Онлайн",
                        laboratory_center: "Лабораторія Центру",
                    },
                    format: {
                        online: "Онлайн",
                        offline: "Офлайн",
                        hybrid: "Гібридний",
                    },
                    viewEvents: "Перегляд події",
                    createEvents: "Створити подію",
                    editEvents: "Редагувати подію",
                    view: "Переглянути",
                    edit: "Редагувати",
                    delete: "Видалити",
                    deleteConfirmTitle: "Видалити подію",
                    deleteConfirmMessage:
                        "Ви впевнені, що хочете видалити цю подію?",
                    deleteConfirmDelete: "Видалити",
                    deleteConfirmText:
                        "Ця дія є незворотною. Будь ласка, підтвердіть, що ви хочете видалити цю подію.",
                    copy: "Скопіювати айді в буфер обміну",
                    eventsUpdated: "Подію успішно оновлено",
                },
                management: {
                    table: {
                        fullName: "Повне ім'я",
                        position: "Посада",
                        imgUrl: "Головне зображення",
                        creatorId: "ID автора керівництва",
                        isActive: "Чи активний",
                    },
                    viewManagement: "Перегляд керівництва",
                    createManagement: "Додати керівництво",
                    editManagement: "Редагувати керівництво",
                    view: "Переглянути",
                    edit: "Редагувати",
                    delete: "Видалити",
                    deleteConfirmTitle: "Видалити керівництво",
                    deleteConfirmMessage:
                        "Ви впевнені, що хочете видалити це керівництво?",
                    deleteConfirmDelete: "Видалити",
                    deleteConfirmText:
                        "Ця дія є незворотною. Будь ласка, підтвердіть, що ви хочете видалити цe керівництво.",
                    copy: "Скопіювати айді в буфер обміну",
                    managementUpdated: "Керівництво успішно оновлено",
                },
                partners: {
                    table: {
                        title: "Заголовок",
                        description: "Опис",
                        imgUrl: "Головне зображення",
                        creatorId: "ID автора партнера",
                        isActive: "Чи активний",
                        websiteUrl: "Вебсайт партнера",
                    },
                    viewManagement: "Перегляд керівництва",
                    createPartner: "Додати партнера",
                    editPartner: "Редагувати партнера",
                    view: "Переглянути",
                    edit: "Редагувати",
                    delete: "Видалити",
                    deleteConfirmTitle: "Видалити партнера",
                    deleteConfirmMessage:
                        "Ви впевнені, що хочете видалити цього партнера?",
                    deleteConfirmDelete: "Видалити",
                    deleteConfirmText:
                        "Ця дія є незворотною. Будь ласка, підтвердіть, що ви хочете видалити цього партнера.",
                    copy: "Скопіювати айді в буфер обміну",
                },
                developmentHistory: {
                    table: {
                        title: "Заголовок",
                        description: "Опис",
                        stageDateTime: "Дата і час етапу",
                        imageUrl: "Зображення",
                        creatorId: "ID автора",
                    },
                    viewHistory: "Перегляд історії",
                    createHistory: "Створити запис",
                    editHistory: "Редагувати запис",
                    createDevelopmentHistory: "Створити запис історії розвитку",
                    editDevelopmentHistory: "Редагувати запис історії розвитку",
                    view: "Переглянути",
                    edit: "Редагувати",
                    delete: "Видалити",
                    deleteConfirmTitle: "Видалити запис",
                    deleteConfirmText:
                        "Ця дія є незворотною. Будь ласка, підтвердіть, що ви хочете видалити цей запис.",
                    copy: "Скопіювати айді в буфер обміну",
                },
                systemEvents: {
                    table: {
                        id: "Ідентифікатор",
                        parentId: "ID Батьківського об'єкта",
                        parentType: "Тип батьківського об'єкта",
                        userId: "ID Користувача",
                        eventType: "Тип події",
                        metaData: "Користувач",
                        createdAt: "Дата створення",
                        updatedAt: "Дата оновлення",
                        actions: "Дії",
                    },
                    filters: {
                        parentId: "ID Батьківського об'єкта",
                        parentType: "Тип батьківського об'єкта",
                        eventType: "Тип події",
                        parentIdPlaceholder: "Введіть ID",
                        parentTypePlaceholder: "Оберіть тип",
                        eventTypePlaceholder: "Оберіть подію",
                    },
                    parentTypes: {
                        [SystemEventParentType.USER]: "Користувач",
                        [SystemEventParentType.ROLE]: "Роль",
                        [SystemEventParentType.PRODUCT_FEATURE]:
                            "Функція продукту",
                        unknown: "Невідомий тип",
                    },
                    eventTypes: {
                        [SystemEventType.NONE]: "Немає",
                        [SystemEventType.USER_REGISTERED]:
                            "Користувач зареєстрований",
                        [SystemEventType.USER_REGISTRATION_COMPLETED]:
                            "Реєстрація завершена",
                        [SystemEventType.USER_LOGGED_IN]: "Користувач увійшов",
                        [SystemEventType.USER_LOGGED_OUT]: "Користувач вийшов",
                        [SystemEventType.USER_PASSWORD_RESET_REQUESTED]:
                            "Запит на скидання паролю",
                        [SystemEventType.USER_PASSWORD_RESET_COMPLETED]:
                            "Пароль скинуто",
                        [SystemEventType.USER_REGISTRATION_FAILED]:
                            "Помилка реєстрації",
                        [SystemEventType.USER_LOGIN_FAILED]: "Помилка входу",
                        [SystemEventType.USER_LOGOUT_FAILED]: "Помилка виходу",
                        [SystemEventType.USER_PASSWORD_RESET_REQUEST_FAILED]:
                            "Помилка запиту скидання паролю",
                        [SystemEventType.USER_PASSWORD_RESET_FAILED]:
                            "Помилка скидання паролю",
                        [SystemEventType.ROLE_ADDED]: "Роль додана",
                        [SystemEventType.ROLE_UPDATED]: "Роль оновлена",
                        [SystemEventType.ROLE_DELETED]: "Роль видалена",
                        [SystemEventType.PRODUCT_FEATURE_ADDED]:
                            "Функція додана",
                        [SystemEventType.PRODUCT_FEATURE_UPDATED]:
                            "Функція оновлена",
                        [SystemEventType.PRODUCT_FEATURE_DELETED]:
                            "Функція видалена",
                        unknown: "Невідома подія",
                    },
                },
                courses: {
                    table: {
                        title: "Заголовок",
                        shortContent: "Короткий зміст",
                        description: "Опис курсу",
                        author: "Автор",
                        duration: "Тривалість",
                        topic: "Тема курсу",
                        creatorId: "ID автора",
                    },
                    filters: {
                        title: "Заголовок",
                        description: "Опис курсу",
                        author: "Автор",
                        duration: "Тривалість",
                        topic: "Тема курсу",
                    },
                    viewCourses: "Перегляд курсів",
                    createCourse: "Створити курс",
                    editCourse: "Редагувати курс",
                    view: "Переглянути",
                    edit: "Редагувати",
                    delete: "Видалити",
                    deleteConfirmTitle: "Видалити курс",
                    deleteConfirmMessage:
                        "Ви впевнені, що хочете видалити цей курс?",
                    deleteConfirmDelete: "Видалити",
                    deleteConfirmText:
                        "Ця дія є незворотною. Будь ласка, підтвердіть, що ви хочете видалити цей курс.",
                    copy: "Скопіювати айді в буфер обміну",
                    courseUpdated: "Курс успішно оновлено",
                },
                contacts: {
                    title: "Контакти",
                    editContacts: "Редагувати контакти",
                    createContacts: "Створити контакти",
                    table: {
                        address: "Адреса",
                        phone: "Телефон",
                        email: "Email",
                        director: "Директор",
                    },
                    noContacts: "Контакти відсутні",
                    selectDirector: "Виберіть директора",
                    noDirector: "Без директора",
                },
            },
            richTextEditor: {
                insertTable: "Вставити таблицю",
                customSize: "Власний розмір...",
                customSizeTitle: "Розмір таблиці",
                rows: "Рядки",
                columns: "Стовпці",
                insert: "Вставити",
                cancel: "Скасувати",
                invalidSize: "Введіть значення від 1 до {{max}}",
                insertRowAbove: "Вставити рядок вище",
                insertRowBelow: "Вставити рядок нижче",
                insertColumnLeft: "Вставити стовпець ліворуч",
                insertColumnRight: "Вставити стовпець праворуч",
                deleteRow: "Видалити рядок",
                deleteColumn: "Видалити стовпець",
                deleteTable: "Видалити таблицю",
            },
            messages: {
                received: "Список користувачів отримано",
                rolesReceived: "Список ролей отримано",
                newsReceived: "Список новин отримано",
                productFeaturesReceived: "Список функцій продукту отримано",
                systemEventsReceived: "Список системних подій отримано",
                changesApplied: "Зміни були застосовані",
                roleFeaturesUpdated:
                    "Функції для ролі '{{roleName}}' були оновлені.",
            },
        },
    },

    en: {
        translation: {
            languages: {
                [Langs.UA]: "Ukrainian",
                [Langs.EN]: "English",
            },
            pagination: {
                show: "Show",
                [PaginationEnum.SHOW_ALL]: "All",
                [PaginationEnum.SHOW_10]: "10",
                [PaginationEnum.SHOW_20]: "20",
                [PaginationEnum.SHOW_50]: "50",
                [PaginationEnum.SHOW_100]: "100",
            },
            errors: {
                common: "Unexpected error",
                validation: {
                    min: "Minimal value ",
                    max: "Maximum value ",
                    required: "Required field",
                    invalidOption: "Invalid option",
                    invalidNumber: "Invalid number",
                    invalidEmail: "Invalid email address",
                    requireAtLeastOne: "Require at least one of fields",
                    invalidPhone: "Invalid phone number",
                    password: {
                        minSymbols: "Minimum number of special characters - 1",
                        minLowercase: "Minimum lowercase character - 1",
                        minUppercase: "Minimum uppercase character - 1",
                        minNumbers: "Minimum number of numbers - 1",
                        passwordsMustMatch: "Passwords do not match",
                    },
                    syntaxError: "Invalid value is present",
                    atLeastOneValidElement:
                        "At least one valid element is required",
                },
                response: {
                    [StatusCodes.UNAUTHORIZED]:
                        "Unauthorized access or incorrect password",
                    [StatusCodes.BAD_REQUEST]: "Invalid value is present",
                },
                deleteFailed: "Failed to delete",
                webSocketConnectionFailed: "Failed to connect to WebSocket server",
            },
            auth: {
                fields: {
                    firstName: "First Name",
                    lastName: "Last Name",
                    middleName: "Middle Name",
                    email: "Email",
                    phone: "Phone",
                    password: "Password",
                    confirmPassword: "Confirm Password",
                },
                actions: {
                    register: "Register",
                    login: "Login",
                    logout: "Logout",
                    changePassword: "Change Password",
                },
                register: {
                    title: "Register",
                    success:
                        "Registration successful! Please check your email for confirmation.",
                },
                login: {
                    title: "Login",
                },
                confirmation: {
                    title: "Registration Confirmation",
                    subtitle: "Please wait while we confirm your registration.",
                    subtitleLink: "Go to Home",
                    inProcess: "Processing...",
                    error: "An error occurred during confirmation.",
                    alreadyExist: "This account has already been confirmed.",
                    expired: "The confirmation token has expired.",
                    success: "Your account has been successfully confirmed!",
                    link: "Go to Login",
                },
            },
            console: {
                sidebar: {
                    expand: "Expand",
                    menu: "Menu",
                    usersPage: "Users page",
                    logOut: "Log out",
                    themetoggle: "Change theme",
                    languageToggle: "Change language",
                    rolesPage: "Roles page",
                    productFeaturesPage: "Product Features",
                    newsPage: "News page",
                    coursesPage: "Courses",
                    systemEventsPage: "System Events",
                    managementPage: "Management",
                    eventsPage: "Events",
                    partnersPage: "Partners",
                    developmentHistoryPage: "Development History",
                    contactsPage: "Contacts",
                },
                common: {
                    cancel: "Cancel",
                    roleId: "Role",
                    filters: "Filters",
                    resetFilters: "Reset filters",
                    apply: "Apply",
                    ok: "OK",
                    uploadImage: "Upload Image",
                    all: "All",
                    save: "Save",
                    saving: "Saving",
                    cover: "Cover",
                    create: "Create",
                    deleteSuccess: "Successfully deleted",
                    success: "Success",
                    translateFromDefault: "Translate from default",
                    fillDefaultLangFirst:
                        "Please fill in the default language first - ",
                },
                users: {
                    table: {
                        id: "ID",
                        email: "Email",
                        role: "Role",
                        firstName: "First Name",
                        lastName: "Last Name",
                        middleName: "Middle Name",
                        phone: "Phone",
                        actions: "Actions",
                    },
                },
                roles: {
                    table: {
                        id: "ID",
                        name: "Name",
                        productFeatureCount: "Product Feature Count",
                        add: "Add feature to role",
                    },
                },
                productFeatures: {
                    table: {
                        id: "ID",
                        name: "Feature Name",
                        description: "Description",
                    },
                },
                news: {
                    table: {
                        title: "Title",
                        shortContent: "Short content",
                        content: "Content",
                        imgUrl: "Main image",
                        creatorId: "Creator ID",
                        isActive: "Is active",
                    },
                    viewNews: "News view",
                    createNews: "Create news",
                    editNews: "Edit news",
                    view: "View",
                    edit: "Edit",
                    delete: "Delete",
                    deleteConfirmTitle: "Delete news",
                    deleteConfirmMessage:
                        "Are you sure you want to delete this news?",
                    deleteConfirmText:
                        "This action is irreversible. Please confirm that you want to delete this news.",
                    copy: "Copy id in clipboard",
                    newsUpdated: "News updated successfully",
                },
                events: {
                    table: {
                        title: "Title",
                        subtitle: "Subtitle",
                        description: "Description",
                        eventDate: "Event date and time",
                        location: "Location",
                        format: "Format",
                        imgUrl: "Main image",
                        creatorId: "Creator ID",
                    },
                    location: {
                        online: "Online",
                        laboratory_center: "Laboratory Center",
                    },
                    format: {
                        online: "Online",
                        offline: "Offline",
                        hybrid: "Hybrid",
                    },
                    viewEvents: "Events view",
                    createEvents: "Create events",
                    editEvents: "Edit events",
                    view: "View",
                    edit: "Edit",
                    delete: "Delete",
                    deleteConfirmTitle: "Delete events",
                    deleteConfirmMessage:
                        "Are you sure you want to delete this events?",
                    deleteConfirmDelete: "Delete",
                    deleteConfirmText:
                        "This action is irreversible. Please confirm that you want to delete this events.",
                    copy: "Copy id in clipboard",
                    eventsUpdated: "Events updated successfully",
                },
                management: {
                    table: {
                        fullName: "Full name",
                        position: "Position",
                        imgUrl: "Main image",
                        creatorId: "Management creator ID",
                        isActive: "Is active",
                    },
                    viewManagement: "Management view",
                    createManagement: "Create management",
                    editManagement: "Edit management",
                    view: "View",
                    edit: "Edit",
                    delete: "Delete",
                    deleteConfirmTitle: "Delete management",
                    deleteConfirmMessage:
                        "Are you sure you want to delete this management?",
                    deleteConfirmDelete: "Delete",
                    deleteConfirmText:
                        "This action is irreversible. Please confirm that you want to delete this management.",
                    copy: "Copy id in clipboard",
                    newsUpdated: "Management updated successfully",
                },
                partners: {
                    table: {
                        title: "Title",
                        description: "Description",
                        imgUrl: "Main image",
                        creatorId: "Partner creator ID",
                        isActive: "Is active",
                        websiteUrl: "Partner website",
                    },
                    viewManagement: "View management",
                    createPartner: "Add partner",
                    editPartner: "Edit partner",
                    view: "View",
                    edit: "Edit",
                    delete: "Delete",
                    deleteConfirmTitle: "Delete partner",
                    deleteConfirmMessage:
                        "Are you sure you want to delete this partner?",
                    deleteConfirmDelete: "Delete",
                    deleteConfirmText:
                        "This action is irreversible. Please confirm that you want to delete this partner.",
                    copy: "Copy ID to clipboard",
                },
                developmentHistory: {
                    table: {
                        title: "Title",
                        description: "Description",
                        stageDateTime: "Stage date and time",
                        imageUrl: "Image",
                        creatorId: "Creator ID",
                    },
                    viewHistory: "View history",
                    createHistory: "Create entry",
                    editHistory: "Edit entry",
                    createDevelopmentHistory:
                        "Create development history entry",
                    editDevelopmentHistory: "Edit development history entry",
                    view: "View",
                    edit: "Edit",
                    delete: "Delete",
                    deleteConfirmTitle: "Delete entry",
                    deleteConfirmText:
                        "This action is irreversible. Please confirm that you want to delete this entry.",
                    copy: "Copy ID to clipboard",
                },
                systemEvents: {
                    table: {
                        id: "ID",
                        parentId: "Parent Object ID",
                        parentType: "Parent Object Type",
                        userId: "User ID",
                        eventType: "Event Type",
                        metaData: "User",
                        createdAt: "Created At",
                        updatedAt: "Updated At",
                        actions: "Actions",
                    },
                    filters: {
                        parentId: "Parent Object ID",
                        parentType: "Parent Object Type",
                        eventType: "Event Type",
                        parentIdPlaceholder: "Enter ID",
                        parentTypePlaceholder: "Select type",
                        eventTypePlaceholder: "Select event",
                    },
                    parentTypes: {
                        [SystemEventParentType.USER]: "User",
                        [SystemEventParentType.ROLE]: "Role",
                        [SystemEventParentType.PRODUCT_FEATURE]:
                            "Product Feature",
                        unknown: "Unknown Type",
                    },
                    eventTypes: {
                        [SystemEventType.NONE]: "None",
                        [SystemEventType.USER_REGISTERED]: "User Registered",
                        [SystemEventType.USER_REGISTRATION_COMPLETED]:
                            "Registration Completed",
                        [SystemEventType.USER_LOGGED_IN]: "User Logged In",
                        [SystemEventType.USER_LOGGED_OUT]: "User Logged Out",
                        [SystemEventType.USER_PASSWORD_RESET_REQUESTED]:
                            "Password Reset Requested",
                        [SystemEventType.USER_PASSWORD_RESET_COMPLETED]:
                            "Password Reset Completed",
                        [SystemEventType.USER_REGISTRATION_FAILED]:
                            "Registration Failed",
                        [SystemEventType.USER_LOGIN_FAILED]: "Login Failed",
                        [SystemEventType.USER_LOGOUT_FAILED]: "Logout Failed",
                        [SystemEventType.USER_PASSWORD_RESET_REQUEST_FAILED]:
                            "Password Reset Request Failed",
                        [SystemEventType.USER_PASSWORD_RESET_FAILED]:
                            "Password Reset Failed",
                        [SystemEventType.ROLE_ADDED]: "Role Added",
                        [SystemEventType.ROLE_UPDATED]: "Role Updated",
                        [SystemEventType.ROLE_DELETED]: "Role Deleted",
                        [SystemEventType.PRODUCT_FEATURE_ADDED]:
                            "Feature Added",
                        [SystemEventType.PRODUCT_FEATURE_UPDATED]:
                            "Feature Updated",
                        [SystemEventType.PRODUCT_FEATURE_DELETED]:
                            "Feature Deleted",
                        unknown: "Unknown Event",
                    },
                },
                courses: {
                    table: {
                        title: "Title",
                        shortContent: "Short content",
                        description: "Description",
                        author: "Author",
                        duration: "Duration",
                        topic: "Course Topic",
                        creatorId: "Creator ID",
                    },
                    filters: {
                        title: "Title",
                        shortContent: "Short content",
                        description: "Description",
                        author: "Author",
                        duration: "Duration",
                        topic: "Course Topic",
                    },
                    viewCourses: "View courses",
                    createCourse: "Create course",
                    editCourse: "Edit course",
                    view: "View",
                    edit: "Edit",
                    delete: "Delete",
                    deleteConfirmTitle: "Delete course",
                    deleteConfirmMessage:
                        "Are you sure you want to delete this course?",
                    deleteConfirmDelete: "Delete",
                    deleteConfirmText:
                        "This action is irreversible. Please confirm that you want to delete this course.",
                    copy: "Copy ID to clipboard",
                    courseUpdated: "Course updated successfully",
                },
                contacts: {
                    title: "Contacts",
                    editContacts: "Edit contacts",
                    createContacts: "Create contacts",
                    table: {
                        address: "Address",
                        phone: "Phone",
                        email: "Email",
                        director: "Director",
                    },
                    noContacts: "No contacts available",
                    selectDirector: "Select a director",
                    noDirector: "No director",
                },
            },
            richTextEditor: {
                insertTable: "Insert table",
                customSize: "Custom size...",
                customSizeTitle: "Table size",
                rows: "Rows",
                columns: "Columns",
                insert: "Insert",
                cancel: "Cancel",
                invalidSize: "Enter a value between 1 and {{max}}",
                insertRowAbove: "Insert row above",
                insertRowBelow: "Insert row below",
                insertColumnLeft: "Insert column left",
                insertColumnRight: "Insert column right",
                deleteRow: "Delete row",
                deleteColumn: "Delete column",
                deleteTable: "Delete table",
            },
            messages: {
                received: "Users received",
                rolesReceived: "Roles received",
                newsReceived: "News received",
                productFeaturesReceived: "Product features received",
                systemEventsReceived: "System events received",
                changesApplied: "Changes has been applied",
                roleFeaturesUpdated:
                    "Features for role '{{roleName}}' were updated.",
            },
        },
    },
};
